import { useLocation, useNavigate, useParams, } from "react-router-dom";
import { useUser } from "../Context/userContext";

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();
        const userContext = useUser();

        return (
            <Component
                {...props}
                router={{ location, navigate, params }}
                userContext = {userContext}
            />
        );
    }

    return ComponentWithRouterProp;
}

export default withRouter;